import { render, staticRenderFns } from "./SetUpTab.vue?vue&type=template&id=5c65ae6c&scoped=true&"
import script from "./SetUpTab.vue?vue&type=script&lang=js&"
export * from "./SetUpTab.vue?vue&type=script&lang=js&"
import style0 from "./SetUpTab.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SetUpTab.vue?vue&type=style&index=1&id=5c65ae6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65ae6c",
  null
  
)

export default component.exports